import { render } from "./kebijakan.vue?vue&type=template&id=3140501d"
import script from "./kebijakan.vue?vue&type=script&lang=js"
export * from "./kebijakan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__